__turbopack_context__.v({
  "background": "TransitionContainer-module-scss-module__Cf-vMG__background",
  "foreground": "TransitionContainer-module-scss-module__Cf-vMG__foreground",
  "hide": "TransitionContainer-module-scss-module__Cf-vMG__hide",
  "logo": "TransitionContainer-module-scss-module__Cf-vMG__logo",
  "mask": "TransitionContainer-module-scss-module__Cf-vMG__mask",
  "stack-module-0": "TransitionContainer-module-scss-module__Cf-vMG__stack-module-0",
  "stack-module-1": "TransitionContainer-module-scss-module__Cf-vMG__stack-module-1",
  "stack-module-10": "TransitionContainer-module-scss-module__Cf-vMG__stack-module-10",
  "stack-module-11": "TransitionContainer-module-scss-module__Cf-vMG__stack-module-11",
  "stack-module-12": "TransitionContainer-module-scss-module__Cf-vMG__stack-module-12",
  "stack-module-13": "TransitionContainer-module-scss-module__Cf-vMG__stack-module-13",
  "stack-module-14": "TransitionContainer-module-scss-module__Cf-vMG__stack-module-14",
  "stack-module-15": "TransitionContainer-module-scss-module__Cf-vMG__stack-module-15",
  "stack-module-16": "TransitionContainer-module-scss-module__Cf-vMG__stack-module-16",
  "stack-module-17": "TransitionContainer-module-scss-module__Cf-vMG__stack-module-17",
  "stack-module-18": "TransitionContainer-module-scss-module__Cf-vMG__stack-module-18",
  "stack-module-19": "TransitionContainer-module-scss-module__Cf-vMG__stack-module-19",
  "stack-module-2": "TransitionContainer-module-scss-module__Cf-vMG__stack-module-2",
  "stack-module-20": "TransitionContainer-module-scss-module__Cf-vMG__stack-module-20",
  "stack-module-3": "TransitionContainer-module-scss-module__Cf-vMG__stack-module-3",
  "stack-module-4": "TransitionContainer-module-scss-module__Cf-vMG__stack-module-4",
  "stack-module-5": "TransitionContainer-module-scss-module__Cf-vMG__stack-module-5",
  "stack-module-6": "TransitionContainer-module-scss-module__Cf-vMG__stack-module-6",
  "stack-module-7": "TransitionContainer-module-scss-module__Cf-vMG__stack-module-7",
  "stack-module-8": "TransitionContainer-module-scss-module__Cf-vMG__stack-module-8",
  "stack-module-9": "TransitionContainer-module-scss-module__Cf-vMG__stack-module-9",
  "transition": "TransitionContainer-module-scss-module__Cf-vMG__transition",
  "z-base": "TransitionContainer-module-scss-module__Cf-vMG__z-base",
  "z-content": "TransitionContainer-module-scss-module__Cf-vMG__z-content",
  "z-footer": "TransitionContainer-module-scss-module__Cf-vMG__z-footer",
  "z-header": "TransitionContainer-module-scss-module__Cf-vMG__z-header",
  "z-hero": "TransitionContainer-module-scss-module__Cf-vMG__z-hero",
  "z-logo": "TransitionContainer-module-scss-module__Cf-vMG__z-logo",
  "z-logo-effect": "TransitionContainer-module-scss-module__Cf-vMG__z-logo-effect",
  "z-navigation": "TransitionContainer-module-scss-module__Cf-vMG__z-navigation",
  "z-sub": "TransitionContainer-module-scss-module__Cf-vMG__z-sub",
});
